module.exports = __webpack_public_path__ + "static/img/korisnici2.52a35dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/korisnici2.png
// module id = 0+Pj
// module chunks = 0